type EventOverlayProps = {
  visible: boolean;
  url: string;
  onClose: () => void;
  zIndexClass?: string;
};

export default function EventOverlay({
  visible,
  url,
  onClose,
  zIndexClass = "z-[10010]",
}: EventOverlayProps) {
  if (!visible || !url) return null;
  return (
    <div className={`fixed inset-0 ${zIndexClass} bg-black flex flex-col`}>
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-[10011] w-10 h-10 bg-black/60 hover:bg-black/80 text-white rounded-full flex items-center justify-center transition-all cursor-pointer backdrop-blur-sm"
        aria-label="닫기"
      >
        <i className="ri-close-line text-xl"></i>
      </button>
      <iframe
        src={url}
        className="w-full h-full border-0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Event Content"
      />
    </div>
  );
}
